import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container } from '@mui/material';
import Register from './components/Register';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import CreateKey from './components/CreateKey';
import VerifyEmail from './components/VerifyEmail';
import SetupPassword from './components/SetupPassword';
import ResetPassword from './components/ResetPassword';
import ForgotPassword from './components/ForgotPassword';
import JobDashboard from './components/JobDashboard';
import Demo from './components/Demo';
import TermsAndConditions from './components/TermsAndConditions';
import Account from './components/Account';
import RoadmapPage from './components/RoadmapPage';
import ContactPage from './components/ContactPage';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

function App() {
  return (
    <Router>
      <Navbar />
      <Container sx={{ mt: 4 }}>
        <Routes>
          <Route path="/" element={<Demo />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify/:token" element={<VerifyEmail />} />
          <Route path="/setup-password/:setupToken" element={<SetupPassword />} />
          <Route path="/reset-password/:resetToken" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/jobs" element={<JobDashboard />} />
          <Route path="/account" element={<Account />} />
          <Route path="/create-key" element={<CreateKey />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/roadmap" element={<RoadmapPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Container>
      <Footer />
    </Router>
  );
}

export default App; 